import { render, staticRenderFns } from "./_base-form-group.vue?vue&type=template&id=3bd0c452&scoped=true&"
import script from "./_base-form-group.vue?vue&type=script&lang=js&"
export * from "./_base-form-group.vue?vue&type=script&lang=js&"
import style0 from "./_base-form-group.vue?vue&type=style&index=0&id=3bd0c452&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd0c452",
  null
  
)

export default component.exports